/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconHelpFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconHelpFilled({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconHelpFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconHelpFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-ZVY44N': alignSelf,'--mt-2-ZVY44N': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZVY44N': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZVY44N': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZVY44N': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZVY44N': opacity,'--w-10-ZVY44N': typeof width === 'number' ? `${width}px` : width,'--h-11-ZVY44N': typeof height === 'number' ? `${height}px` : height,'--a-7-ZVY44N': isAnimated ? animation : "none",'--sd-8-ZVY44N': isAnimated ? strokeDashoffset : 0,'--sd-9-ZVY44N': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconHelpFilled.SvgPath"
  data-view-path={viewPath}
 d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
 style={{'--f-12-ZVY44N': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}